export default {
  gerente: {
    titulo: "Gerente",
    nome: "Nome",
    email: "E-mail",
    telefone: "Telefone",
    situacao: "Situação",
    ativo: "Ativo",
    inativo: "Inativo",
    campoObrigatorio: "Campo obrigatório",
    identificacao: "Identificação",
    cadastro: "Cadastro de gerente",
    salvar: "Salvar",
    cancelar: "Cancelar",
    emailInvalido: "E-mail inválido",
    naoFoiPossivelInserir: "Não foi possível inserir o gerente",
    salvando: "Salvando",
    atualizando: "Atualizando",
    cadastradoComSucesso: "Gerente cadastrado com sucesso",
    editadoComSucesso: "Gerente editado com sucesso",
    falhaAoCarregar: "Falha ao carregar gerente",
    naoFoiPossivelEditar: "Não foi possivel editar gerente",
    emailDuplicado: "Este email já está em uso",
    numeroMaximoGerente: "O limite de usuários desse plano foi atingido",
    falhaAoExcluirGerente: "Falha ao excluir gerente",
    gerenteExcluidoComSucesso: "Gerente excluido com sucesso",
    excluir: "Excluir",
    excluindo: "Excluindo",
    desejaExcluir: "Deseja excluir?",
    nao: "Não",
    telefoneInvalido: "Telefone inválido"
  }
};
